import { render, staticRenderFns } from "./DataManageStudentPackages.vue?vue&type=template&id=2aa83a97&scoped=true"
import script from "./DataManageStudentPackages.vue?vue&type=script&lang=js"
export * from "./DataManageStudentPackages.vue?vue&type=script&lang=js"
import style0 from "./DataManageStudentPackages.vue?vue&type=style&index=0&id=2aa83a97&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa83a97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aa83a97')) {
      api.createRecord('2aa83a97', component.options)
    } else {
      api.reload('2aa83a97', component.options)
    }
    module.hot.accept("./DataManageStudentPackages.vue?vue&type=template&id=2aa83a97&scoped=true", function () {
      api.rerender('2aa83a97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/managePackages/components/DataManageStudentPackages.vue"
export default component.exports